export const specialization = [
    {
        id: 1,
        title: "Inspeksi",
        subtitle: "Pemeriksaan visual dan teknis alat kerja.",
        image: require('../images/specialization/1.jpg')
    },
    {
        id: 2,
        title: "Pengujian",
        subtitle: "Uji kelayakan alat sesuai standar K3.",
        image: require('../images/specialization/2.jpg')
    },
    {
        id: 3,
        title: "Evaluasi",
        subtitle: "Analisis hasil inspeksi dan pengujian.",
        image: require('../images/specialization/3.jpg')
    },
    {
        id: 4,
        title: "Validasi",
        subtitle: "Verifikasi akhir sebelum alat digunakan.",
        image: require('../images/specialization/4.jpg')
    }
];
